import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { faqs } from '../../data/salesContent';
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-cream px-5 py-20 md:py-28" data-id="element-98" data-mp="uqj258fdg88g">
      <div className="mx-auto max-w-3xl" data-id="element-99" data-mp="ut5a3966cpr7">
        <SectionHeading title="Preguntas frecuentes" data-id="element-100" data-mp="70f1n9xhcolo" />
        <ul className="mt-12 space-y-3" data-id="element-101" data-mp="731jc2e34khm">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <li key={f.q} className={`rounded-xl border bg-white transition-colors duration-200 ${isOpen ? 'border-rose/50' : 'border-line'}`} data-id="element-102" data-mp="gze7ylurw85i" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 rounded-xl px-6 py-5 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-rose/40" data-id="element-103" data-mp="bzi8mzx0t4wa">
                  <span className="text-base font-semibold text-ink md:text-lg" data-id="element-104" data-mp="hu8wl1jaksjt">{f.q}</span>
                  <PlusIcon className={`h-5 w-5 shrink-0 text-rose-dark transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-105" data-mp="msk7lflbp93m" />
                </button>
                <AnimatePresence initial={false} data-id="element-106" data-mp="vtia1tg458k3">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-107" data-mp="vsyw0ntl34bc">
                      <p className="px-6 pb-6 text-base leading-relaxed text-ink-muted md:text-lg" data-id="element-108" data-mp="cwqyk66tbxql">{f.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}